import React, { useState } from 'react';
import styled from 'astroturf/react';

import { TextButton } from 'js/design_system/TextButton';
import { Body } from 'js/design_system/Body';
import _Question from "WhoCanSeePost-Question.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/CreateSocialItem/WhoCanSeePost.tsx?styleId=Question";
import _Answer from "WhoCanSeePost-Answer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/CreateSocialItem/WhoCanSeePost.tsx?styleId=Answer";


const Question = /*#__PURE__*/styled(TextButton, null, {
  displayName: "Question",
  styles: _Question
});

const Answer = /*#__PURE__*/styled(Body, null, {
  displayName: "Answer",
  styles: _Answer
});

const WhoCanSeePost: React.FunctionComponent = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <Question onClick={() => setExpanded((v) => !v)}>
        Who can see my post?
      </Question>
      {expanded && (
        <Answer>
          Your followers and profile visitors may see your post on Academia.edu.
          Posts that are interesting or relevant may also be shown to other
          users.
        </Answer>
      )}
    </>
  );
};

export default WhoCanSeePost;
